<template>
  <div class="detail">
    <div class="head">装箱明细</div>
    <!-- 配送单号 -->
    <div class="porder">
      {{ $t("message.deliveryNoteNumber") }}: {{ porder_sn }}
      <!-- 导出装箱明细 -->
      <a :href="baseURL + '/download.porderFreightExcel?porder_sn=' + porder_sn" target="_blank"
        rel="noopener noreferrer" style="color: #fff" class="fr">
        <el-button type="primary" size="small">
          {{ $t("message.exportPackingDetails") }}
        </el-button>
      </a>
    </div>
    <!--列表 -->
    <div class="logisticsList" v-for="(item, index) in detail" :key="index">
      <!-- 发送方式 -->
      <div class="wayToSend">
        {{ $t("message.wayToSend") }}：{{ item.logistics_name }}
      </div>
      <!-- 物流盒子 -->
      <div class="logistics-box">
        <ol>
          <!-- 箱号 -->
          <li class="flex05">{{ $t("message.boxNO") }}</li>
          <!-- 箱规(cm) -->
          <li>{{ $t("message.boxGauge") }}</li>
          <!-- 实际重量 -->
          <li>{{ $t("message.actualWeight") }}</li>
          <!-- 订单号 -->
          <li class="flex15">
            {{ $t("message.orderNumber") }}
          </li>
          <!-- 番号 -->
          <li>{{ $t("message.mash") }}</li>
          <!-- 照片 -->
          <li>{{ $t("message.pic") }}</li>
          <!-- 商品属性 -->
          <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
          <!-- 装箱数 -->
          <li>{{ $t("message.packingNumber") }}</li>
          <!-- 单价(元) -->
          <li>{{ $t("message.priceYuan") }}</li>
          <!-- 小计(元) -->
          <li>{{ $t("message.SubtotalYuan") }}</li>
          <!-- 标签编号 -->
          <li class="flex15">{{ $t("message.tagNumber") }}</li>
          <!-- 备注单单番备注 -->
          <li class="flex2">{{ $t("message.remarksSingleRemarks") }}</li>
        </ol>
        <!-- 列表了 -->
        <div class="list" v-for="(box, boxIndex) in item.list" :key="boxIndex">
          <!-- 箱号 -->
          <div class="item flex05" style="padding-right: 0.5px">
            {{ box.number }}
          </div>
          <!-- 箱规(cm)  -->
          <div class="item" style="padding-left: 0.5px">
            {{ box.length }} x {{ box.width }} x {{ box.height }}
          </div>
          <!-- 实际重量 -->
          <div class="item">{{ box.weight }}</div>
          <div class="order">
            <div class="order-list" v-for="(order, orderIndex) in box.porder_freight_detail" :key="orderIndex">
              <div class="order_sn">{{ order.order_sn }}</div>
              <div class="commodity">
                <div class="commodity-list" v-for="(commodity, commodityIndex) in order.list" :key="commodityIndex">
                  <!-- 番号 -->
                  <div class="item">{{ commodity.order_detail.sorting }}</div>
                  <!-- 图片 -->
                  <div class="item">
                    <el-image :src="commodity.order_detail.pic" style="width: 60px"></el-image>
                  </div>
                  <!-- 商品属性 -->
                  <div class="item flex15">
                    <div class="template">
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          <div class="row" v-for="(itemDetail, itemIndex) in commodity.order_detail.detail_y"
                            :key="itemIndex" style="margin-bottom: 5px">
                            {{ itemDetail.key }}：{{ itemDetail.value }}
                          </div>
                        </div>
                        <div>
                          <div class="row" v-for="(itemDetail, itemIndex) in commodity.order_detail.detail_y"
                            :key="itemIndex">
                            {{ itemDetail.key }}：{{ itemDetail.value }}
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                  <!-- 装箱数 -->
                  <div class="item">{{ commodity.num }}</div>
                  <!-- 单价(元) -->
                  <div class="item">
                    {{ commodity.order_detail.confirm_price }}
                  </div>
                  <!-- 小计(元)) -->
                  <div class="item">
                    {{ (commodity.num * commodity.order_detail.confirm_price).toFixed(2) }}
                  </div>
                  <!-- 标签编号 -->
                  <div class="item flex15">
                    <div class="template">
                      <div class="row" v-for="( itemDetail, itemIndex ) in commodity.porder_detail_tag"
                        :key="itemIndex">
                        <p>类别： {{ itemDetail.type }}</p>
                        <p>标签号： {{ itemDetail.no }}</p>
                        <p>商品码： {{ itemDetail.goods_no }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="item flex2">
                    {{ commodity.porder_detail_remark }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      detail: [],
    };
  },
  created() {
    this.porderFreightDetailList();
  },
  methods: {
    porderFreightDetailList() {
      let datas = {
        porder_sn: this.porder_sn,
      };
      this.$api.porderApi.porderFreightDetailList(datas).then((res) => {
        this.detail = res.data;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.detail {
  min-width: 1910px;

  .head {
    padding: 24px;
    background-color: #32323c;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
  }

  .porder {
    padding: 19px 24px;
    margin: 24px;
    line-height: 32px;
    color: #b4272d;
    font-weight: bold;
    font-size: 20px;
    line-height: 32px;
    background: #f8f8f8;
    border-radius: 8px;
  }

  .logisticsList {
    padding: 34px 24px;
    background: #f8f8f8;
    border-radius: 8px;
    margin: 24px;

    .wayToSend {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 24px;
    }

    .logistics-box {
      border: 2px solid #32323c;
      border-radius: 4px;

      ol {
        display: flex;
        background: #ebebeb;
        border-bottom: 1px solid #120e0f;

        li {
          font-weight: bold;
          color: #333333;
          padding: 22px 0;
        }
      }

      li {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #120e0f;

        &:nth-last-child(1) {
          border-right: 0;
        }
      }

      .list {
        display: flex;
        border-bottom: 1px solid #120e0f;

        &:nth-last-child(1) {
          border: 0;
        }

        .item {
          flex: 1;
          border-right: 1px solid #120e0f;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .order {
          flex: 11.63;

          .order-list {
            display: flex;
            border-bottom: 1px solid #120e0f;

            &:nth-last-child(1) {
              border: 0;
            }

            .order_sn {
              flex: 1.5;
              //   padding-left: 1px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-right: 1px solid #120e0f;

              &:nth-last-child(1) {
                border: 0;
              }
            }

            .commodity {
              flex: 10;

              .commodity-list {
                display: flex;
                border-bottom: 1px solid #120e0f;

                &:nth-last-child(1) {
                  border: 0;
                }
              }

              .item {
                padding: 10px 0;

                .template {
                  width: 95%;
                  text-align: left;
                }

                &:nth-last-child(1) {
                  border-right: 0;
                }
              }
            }
          }
        }
      }

      .flex05 {
        flex: 0.5 !important;
      }

      .flex15 {
        flex: 1.5 !important;
      }

      .flex2 {
        flex: 2 !important;
      }
    }
  }
}
</style>